import React from 'react';
import easydropdown from 'easydropdown';

export default class Select extends React.Component {
    setSelectElementRef = (selectElement) => {
        this.selectElement = selectElement;
    };

    componentDidMount = () => {
        this.edd = easydropdown(this.selectElement, {
            behavior: {
                liveUpdates: true,
                maxVisibleItems: 8,
                showPlaceholderWhenOpen: false,
            },
        });
    };

    componentWillUnmount() {
        this.edd.destroy();
    }

    render = () => {
        const { name, id, onChange, options } = this.props;
        const defaultValue = this.props.default;

        return (
            <select name={name} id={id} onChange={onChange} className="dropdown__select" ref={this.setSelectElementRef}>
                <option value="" data-placeholder>
                    {defaultValue}
                </option>
                {options}
            </select>
        );
    };
}
